import { Link } from 'react-router-dom';
import { heroData } from '@/mocks/home';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[580px] md:h-[700px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%20warm%20gradient%20flowing%20shapes%20with%20soft%20coral%20and%20amber%20tones%2C%20modern%20minimalist%20design%2C%20smooth%20organic%20curves%2C%20artistic%20background%20with%20subtle%20texture%2C%20light%20airy%20atmosphere%2C%20contemporary%20aesthetic%2C%20warm%20inviting%20colors&width=1800&height=900&seq=hero-bg-luluca&orientation=landscape"
          alt="luluca 智能创作平台"
          className="w-full h-full object-cover"
          loading="eager"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/35 via-black/20 to-black/45"></div>

      <div className="relative z-10 w-full max-w-4xl mx-auto px-4 md:px-6 text-center">
        <h1 className="text-4xl md:text-6xl lg:text-7xl font-heading font-bold text-white mb-6 leading-tight">
          {heroData.title}
        </h1>
        <p className="text-base md:text-lg text-white/80 max-w-2xl mx-auto mb-10 leading-relaxed">
          {heroData.subtitle}
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link
            to="/categories"
            className="inline-flex items-center px-8 py-3.5 rounded-full bg-primary-500 text-background-50 text-sm md:text-base font-semibold whitespace-nowrap hover:bg-primary-600 transition-all duration-300 cursor-pointer shadow-lg shadow-primary-500/30"
          >
            {heroData.ctaPrimary}
            <i className="ri-arrow-right-line ml-2"></i>
          </Link>
          <Link
            to="/about"
            className="inline-flex items-center px-8 py-3.5 rounded-full border-2 border-white/40 text-white text-sm md:text-base font-semibold whitespace-nowrap hover:bg-white/10 transition-all duration-300 cursor-pointer"
          >
            {heroData.ctaSecondary}
          </Link>
        </div>
      </div>
    </section>
  );
}